import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { WelfareBenefitsListType } from 'types/kodawari';

/**
 * 待遇・福利厚生に関するカスタムフック
 * @param initialWelfareBenefitsList
 * @returns 待遇・福利厚生の値と更新する関数を含むオブジェクト
 */
export const useWelfareBenefits = (
  initialWelfareBenefitsList: WelfareBenefitsListType[]
) => {
  const [welfareBenefitsList, setWelfareBenefitsList] = useState<
    WelfareBenefitsListType[]
  >(initialWelfareBenefitsList);

  const selectedWelfareBenefitsList = welfareBenefitsList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedWelfareBenefitsList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = welfareBenefitsList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setWelfareBenefitsList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateWelfareBenefitsListJobCount = (
    requirementsJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setWelfareBenefitsList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(requirementsJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedWelfareBenefitsList = () => {
    const checkedList = welfareBenefitsList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setWelfareBenefitsList(checkedList);
  };

  return {
    welfareBenefitsList,
    selectedWelfareBenefitsList,
    updateIsCheckedWelfareBenefitsList,
    updateWelfareBenefitsListJobCount,
    clearIsCheckedWelfareBenefitsList,
  };
};
